// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cYEJ","input":"styles_input__3r_-U"};